import ctl from '@netlify/classnames-template-literals';

const headerRowStyle = ctl(`
  text-left
  text-md
`);

const headerCellStyle = ctl(`
  offset-base
  font-[500]
`);

export { headerRowStyle, headerCellStyle };
